import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=efffadce&scoped=true"
import script from "./AddressBlock.vue?vue&type=script&lang=js"
export * from "./AddressBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efffadce",
  null
  
)

export default component.exports